import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "../common/components/Grid";
import Select from "../common/components/Select";
import { ReactNodeDialog } from "../common/utils/dialogUtlities";
import { useEvents } from "../reducers/eventSlice";
import { useJob } from "../reducers/jobSlice";
import { useCADPopout, useSelectedJobid } from "../utils/CADStateProvider";
import { EventDetails } from "./EventDetails";
import PanelTitle from "../common/components/PanelTitle";
import PropTypes from 'prop-types';
import DefaultButton from "../common/components/DefaultButton";
import useClientConfig from "../common/hooks/clientConfigHook";

const EventInfo = ({ eventid, hideSelector }) => {
    const { t } = useTranslation();
    const events = useEvents();
    const [selectedEvent, setSelectedEvent] = useState(eventid);
    const displayEvent = useMemo(() => events.find(e => e.id == selectedEvent), [events, selectedEvent]);

    useEffect(() => {
        if (eventid) {
            setSelectedEvent(eventid);
        }
    }, [eventid]);

    return <>
        { !hideSelector && <Row>
            <Col>
                <Select value={selectedEvent} placeholder={t('event', { count: 1 })} onChange={id => setSelectedEvent(id)} options={events} labelField="name" valueField="id"></Select>
            </Col>
        </Row> }
        <Row>
            <Col>
                {displayEvent ? <EventDetails event={displayEvent} readonly={true}></EventDetails> : null}
            </Col>
        </Row>
    </>
}
EventInfo.propTypes = {
    eventid: PropTypes.number,
    hideSelector: PropTypes.bool
}

export const EventInfoDialog = ({ eventid, ...props }) => {
    const { t } = useTranslation();

    return <ReactNodeDialog title={t('eventInfo')} size="lg" {...props}>
        <EventInfo eventid={eventid} readonly={true} hideSelector={true}></EventInfo>
    </ReactNodeDialog>
}
EventInfoDialog.propTypes = {
    eventid: PropTypes.number
}

export const EventInfoPanel = () => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const popout = useCADPopout();
    const { selectedJobId } = useSelectedJobid();
    const job = useJob(selectedJobId);
    const [selectedEvent, setSelectedEvent] = useState(job?.event);
    
    useEffect(() => {
        setSelectedEvent(job?.event);
    }, [job?.event]);

    return <div id="eventInfoPanel">
        <PanelTitle title={t('eventInfo')} guide={82715} onPopout={() => popout('eventInfo')}>
            { clientConfig.download_access?.events !== false && <Row>
                <Col></Col>
                <Col xs="auto">
                    <DefaultButton kind="print" disabled={true} onClick={() => {}}></DefaultButton>
                </Col>
            </Row> }
        </PanelTitle>
        <EventInfo eventid={selectedEvent}></EventInfo>
    </div>
}